// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"order-list"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M11 4H22M11 12H22M11 20H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 3H3C3.55228 3 4 3.4514 4 4.00368V10M4 10H2M4 10H6M2 14H5C5.55228 14 6 14.4477 6 15V16.5C6 17.0523 5.55228 17.5 5 17.5H3C2.44772 17.5 2 17.9477 2 18.5V21H6","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const OrderListIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'order-list',
    ref,
    icon: element,
  },
));

OrderListIcon.displayName = 'OrderListIcon';

export default OrderListIcon;
